import React from 'react';
import { COLORS } from '../config/constants';

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, itemType = 'kayıt' }) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.6)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: COLORS.white,
        borderRadius: '12px',
        padding: '2rem',
        maxWidth: '500px',
        width: '90%',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        {/* Header */}
        <div style={{ marginBottom: '1.5rem', textAlign: 'center' }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>⚠️</div>
          <h2 style={{ fontSize: '1.5rem', fontWeight: '700', color: COLORS.text, margin: 0 }}>
            Silme Onayı
          </h2>
        </div>

        {/* Message */}
        <p style={{ 
          color: COLORS.textLight, 
          marginBottom: '2rem',
          textAlign: 'center',
          fontSize: '1rem'
        }}>
          Bu {itemType} silinecek. Bu işlem geri alınamaz!
        </p>

        {/* Buttons */}
        <div style={{ display: 'flex', gap: '1rem' }}>
          <button
            onClick={onClose}
            style={{
              flex: 1,
              padding: '0.875rem',
              background: COLORS.background,
              color: COLORS.text,
              border: 'none',
              borderRadius: '8px',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            İptal
          </button>
          <button
            onClick={handleConfirm}
            style={{
              flex: 1,
              padding: '0.875rem',
              background: COLORS.primary,
              color: COLORS.white,
              border: 'none',
              borderRadius: '8px',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            Evet, Sil
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
